import omit from 'lodash/omit';
import { getLocalName } from 'vet-bones/utils';

import {
  HiddenCategory,
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { DiagramGraphObject } from 'src/containers/ProjectDiagram/types/diagram';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';
import * as copy from 'src/templates/copy';

export const getLabelForIri = (
  labelsByIri: Record<string, string> = {},
  iri: string | null,
  newLabel = ''
) =>
  iri === null || labelsByIri[iri] === ''
    ? newLabel
    : labelsByIri[iri] || getLocalName(iri);

export const getDiagramObjectLabel = (
  labelsByIri: Record<string, string> = {},
  obj: DiagramGraphObject
) => {
  let newLabel: string;
  switch (obj.data.category) {
    case NodeCategory.MODEL_CONCEPT_CLASS: {
      newLabel = copy.components.projectDiagram.modelConceptClass.new;
      break;
    }
    case LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL:
    case LinkCategory.MODEL_CONCEPT_RELATIONSHIP: {
      newLabel = copy.components.projectDiagram.modelConceptRelationship.new;
      break;
    }
    case HiddenCategory.MODEL_CONCEPT_ATTRIBUTE: {
      newLabel = copy.components.projectDiagram.modelConceptAttribute.new;
      break;
    }
    default: {
      newLabel = '';
    }
  }
  return getLabelForIri(labelsByIri || {}, obj.data.value, newLabel);
};

export const getDiagramPartLabel = (
  labelsByIri: Record<string, string> = {},
  obj: go.GraphObject
) =>
  getDiagramObjectLabel(
    labelsByIri || {},
    (obj.part || obj) as DiagramGraphObject
  );

export const setLabelForIri =
  (iri: string, label: string) => (model: Model) => {
    setDataProperty<ModelData>(model)(model.modelData, 'labelsByIri', {
      ...model.modelData.labelsByIri,
      [iri]: label,
    });
  };

export const removeLabelForIri = (iri: string) => (model: Model) => {
  if (model.modelData.labelsByIri[iri] !== undefined) {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'labelsByIri',
      omit(model.modelData.labelsByIri, iri)
    );
  }
};
